import React from 'react';
import AndurilLogo from '@/assets/image/companies/Anduril.png';
import AnthropicLogo from '@/assets/image/companies/Anthropic.png';
import ByteDanceLogo from '@/assets/image/companies/ByteDance.png';
import DatabricksLogo from '@/assets/image/companies/Databricks.png';
import OpenAILogo from '@/assets/image/companies/OpenAI.png';
import SpaceXLogo from '@/assets/image/companies/SpaceX.png';

interface Company {
  name: string;
  image: string;
  link: string;
}

interface BuySell {
  buy: string;
  sell: string;
}

interface WatchListTableData {
  index: number;
  company: Company;
  valuation: string;
  price: string;
  buySell: BuySell;
}

interface WatchListTableProps {
  tableData: WatchListTableData[];
  isWatchList?: boolean;
}

// 图片映射对象
const companyImages: { [key: string]: string } = {
  'Anduril.png': AndurilLogo,
  'Anthropic.png': AnthropicLogo,
  'ByteDance.png': ByteDanceLogo,
  'Databricks.png': DatabricksLogo,
  'OpenAI.png': OpenAILogo,
  'SpaceX.png': SpaceXLogo,
  // 在这里添加更多公司的图片映射
};

export const WatchListTable: React.FC<WatchListTableProps> = ({ tableData }) => {
  return (
    <div className="overflow-x-auto rounded-t-md sm:rounded-t-lg md:rounded-t-xl">
      <table className="min-w-full border-collapse border border-gray-800">
        <thead>
          <tr className="text-xs sm:text-sm md:text-base lg:text-lg pt-3 pb-3 overflow-hidden text-ellipsis whitespace-nowrap font-medium text-white">
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800 border-1 border-left-radius-30 rounded-tl-md sm:rounded-tl-lg md:rounded-tl-xl ">Company</th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800">Last Price</th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800">Last Valuation</th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800  rounded-tr-md sm:rounded-tr-lg md:rounded-tr-xl">
              <div className="flex align-center justify-center">
                <div>Buy</div>
                <div className="px-2">/</div>
                <div>Sell</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => (
            <tr key={index} className="hover:bg-[#333434]">
              <td className="px-2 sm:py-2px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800 border-1">
                <div className="flex items-center">
                  <div className="avatar">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 rounded-full">
                      <img
                          className="rounded-full object-cover w-full h-full"
                          src={companyImages[item.company.image] || ''}
                          alt={item.company.name}
                      />
                    </div>
                  </div>
                  <div className="ml-2 sm:ml-2 md:ml-3">
                    <div className="font-medium text-white text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                      {item.company.link ? (
                        <a href={item.company.link} className="hover:text-blue-400">
                          {item.company.name}
                        </a>
                      ) : (
                        item.company.name
                      )}
                    </div>
                  </div>
                </div>
              </td>
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800 border-1">
                <div className="text-white text-center text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">{item.price}</div>
              </td>
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2whitespace-nowrap border border-gray-800 border-1">
                <div className="text-white text-center text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">{item.valuation}</div>
              </td>
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2whitespace-nowrap border border-gray-800 border-1">
                <div className="flex flex-col gap-1 items-center">
                  <div className="text-center text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                    <div className="flex items-center">
                      <div>{item.buySell.buy}</div>
                      <div className="px-2">/</div>
                      <div>{item.buySell.sell}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
